import { ELLIPSIS as t } from "./Pagination.constant.js";
const g = (i, p) => {
  let l = [1, i - 1, i, i + 1, p];
  return i === 1 && l.push(i + 2), i === p && l.push(i - 2), l = l.filter((s) => s >= 1 && s <= p).sort((s, e) => s - e), l = [...new Set(l)], l.reduce(
    (s, e) => s.length && s[s.length - 1] !== e - 1 ? [...s, t, e] : [...s, e],
    []
  );
};
export {
  g as getPagesToDisplay
};
